import { actions as formActions } from 'react-redux-form'
import isEqual from 'lodash/isEqual'
import { t } from 'ttag'

import bronzeBriefcaseIcon from '@h2/assets/svg/illustrations/upTheLadder/badges/bronze/briefcase.svg'
import silverBriefcaseIcon from '@h2/assets/svg/illustrations/upTheLadder/badges/silver/briefcase.svg'
import inactiveBriefcaseIcon from '@h2/assets/svg/illustrations/upTheLadder/badges/inactive/briefcase.svg'
import goldBriefcaseIcon from '@h2/assets/svg/illustrations/upTheLadder/badges/gold/briefcase.svg'
import bronzeSignIcon from '@h2/assets/svg/illustrations/upTheLadder/badges/bronze/sign.svg'
import silverSignIcon from '@h2/assets/svg/illustrations/upTheLadder/badges/silver/sign.svg'
import inactiveSignIcon from '@h2/assets/svg/illustrations/upTheLadder/badges/inactive/sign.svg'
import goldSignIcon from '@h2/assets/svg/illustrations/upTheLadder/badges/gold/sign.svg'
import bronzeTrophyIcon from '@h2/assets/svg/illustrations/upTheLadder/badges/bronze/trophy.svg'
import silverTrophyIcon from '@h2/assets/svg/illustrations/upTheLadder/badges/silver/trophy.svg'
import inactiveTrophyIcon from '@h2/assets/svg/illustrations/upTheLadder/badges/inactive/trophy.svg'
import goldTrophyIcon from '@h2/assets/svg/illustrations/upTheLadder/badges/gold/trophy.svg'
import bronzeThumbIcon from '@h2/assets/svg/illustrations/upTheLadder/badges/bronze/thumb.svg'
import silverThumbIcon from '@h2/assets/svg/illustrations/upTheLadder/badges/silver/thumb.svg'
import inactiveThumbIcon from '@h2/assets/svg/illustrations/upTheLadder/badges/inactive/thumb.svg'
import goldThumbIcon from '@h2/assets/svg/illustrations/upTheLadder/badges/gold/thumb.svg'
import inactiveUserIcon from '@h2/assets/svg/illustrations/upTheLadder/badges/inactive/user.svg'
import goldUserIcon from '@h2/assets/svg/illustrations/upTheLadder/badges/gold/user.svg'
import inactiveCheckIcon from '@h2/assets/svg/illustrations/upTheLadder/badges/inactive/check.svg'
import goldCheckIcon from '@h2/assets/svg/illustrations/upTheLadder/badges/gold/check.svg'
import inactiveJigsawIcon from '@h2/assets/svg/illustrations/upTheLadder/badges/inactive/jigsaw.svg'
import goldJigsawIcon from '@h2/assets/svg/illustrations/upTheLadder/badges/gold/jigsaw.svg'

import { recordLevelProgress, updateLevel } from './actions/earlyGameboard'

let currentValue = null

export const BADGES_UPDATED = 'BADGES_UPDATED'
export const SET_LEVEL = 'SET_LEVEL'
export const PRE_LEVEL = 'PRE_LEVEL'
export const QUIET_SET_LEVEL = 'QUIET_SET_LEVEL'

const compareMaps = (map1, map2) => {
  if (!map1 && !map2) {
    return true
  }

  if (!map1 || !map2 || map1.size !== map2.size) {
    return false
  }

  //console.log("Maps:", map1, map2)
  for (const key of Object.keys(map1)) {
    let val = map1[key]

    if (val && val.hasOwnProperty('level')) {
      val = val.level
    }

    let testVal = map2[key]

    if (testVal && testVal.hasOwnProperty('level')) {
      testVal = testVal.level
    }

    /*
     * in cases of an undefined value, make sure the key
     * actually exists on the object so there are no false positives
     */
    if (testVal !== val || (testVal === undefined && !map2.has(key))) {
      return false
    }
  }

  return true
}
const checkPathwayBadge = pathwayState => {
  let pathwayIcon = {}
  const numPaths = pathwayState.length

  if (numPaths >= 40) {
    pathwayIcon = {
      level: 3,
      icon: goldSignIcon //'Badges_sign-gold.svg'
    }
  } else if (numPaths >= 10) {
    pathwayIcon = {
      level: 2,
      icon: silverSignIcon //'Badges_sign-silver.svg'
    }
  } else if (numPaths > 0) {
    pathwayIcon = {
      level: 1,
      icon: bronzeSignIcon //'Badges_sign-bronze.svg'
    }
  } else {
    pathwayIcon = {
      level: 0,
      icon: inactiveSignIcon //'Badges_sign-inactive.svg'
    }
  }

  return pathwayIcon
}
const checkOccupationBadge = occupationState => {
  const numOccs = occupationState.length
  let occs = {}

  if (numOccs >= 50) {
    occs = {
      level: 3,
      icon: goldBriefcaseIcon //'Badges_briefcase-gold.svg'
    }
  } else if (numOccs >= 10) {
    occs = {
      level: 2,
      icon: silverBriefcaseIcon //'Badges_briefcase-silver.svg'
    }
  } else if (numOccs > 0) {
    occs = {
      level: 1,
      icon: bronzeBriefcaseIcon //'Badges_briefcase-bronze.svg'
    }
  } else {
    occs = {
      level: 0,
      icon: inactiveBriefcaseIcon //'Badges_briefcase-inactive.svg'
    }
  }

  return occs
}
const clusterVideoBadge = videoViews => {
  const numOccs = videoViews.length
  let occs = {}

  if (numOccs >= 16) {
    occs = {
      level: 3,
      icon: goldTrophyIcon //'Badges_trophy-gold.svg'
    }
  } else if (numOccs >= 10) {
    occs = {
      level: 2,
      icon: silverTrophyIcon //'Badges_trophy-silver.svg'
    }
  } else if (numOccs > 0) {
    occs = {
      level: 1,
      icon: bronzeTrophyIcon //'Badges_trophy-bronze.svg'
    }
  } else {
    occs = {
      level: 0,
      icon: inactiveTrophyIcon //'Badges_trophy-inactive.svg'
    }
  }

  return occs
}
const checkRatingBadge = ratings => {
  const numRatings = ratings.occupations.length + ratings.pathways.length
  let ratingBadge = {}

  if (numRatings >= 60) {
    ratingBadge = {
      level: 3,
      icon: goldThumbIcon //'Badges_thumb-gold.svg'
    }
  } else if (numRatings >= 10) {
    ratingBadge = {
      level: 2,
      icon: silverThumbIcon //'Badges_thumb-silver.svg'
    }
  } else if (numRatings > 0) {
    ratingBadge = {
      level: 1,
      icon: bronzeThumbIcon //'Badges_thumb-bronze.svg'
    }
  } else {
    ratingBadge = {
      level: 0,
      icon: inactiveThumbIcon // 'Badges_thumb-inactive.svg'
    }
  }

  return ratingBadge
}

export const levelName = lvl => {
  switch (lvl) {
    case 1:
      return t`Bronze`
    case 2:
      return t`Silver`
    case 3:
      return t`Gold`
    default:
      return ''
  }
}

let currentLevel = 1
let lastRanFor = 1
const checkLevels = store => {
  const state = store.getState()
  const early = state.early
  const ratings = early.backpack.ratings

  if (lastRanFor !== early.gameboard.progress.levelId) {
    lastRanFor = early.gameboard.progress.levelId
  }

  // console.log(early, lastRanFor, early.gameboard.progress.levelId)

  const numPathways = early.gameboard.activityLog.pathways.length
  const numPathwaysLiked = ratings.pathways.filter(rtng => rtng.rating > 0).length
  const numOccupations = early.gameboard.activityLog.occupations.length
  const numOccupationsLiked = ratings.occupations.filter(rtng => rtng.rating > 0).length
  //const numTools = ratings.tools.length
  const assessmentComplete = !!early.interestActivity.completedAt
  const budgetComplete = !!early.budget.completedAt
  const presentationComplete = !!early.presentation.completedAt
  //console.log(numPathways, numOccupationsLiked, numOccupations, numOccupationsLiked)
  let levelId = state.early.gameboard.progress.levelId

  currentLevel = levelId

  if (numPathwaysLiked >= 3 && numPathways >= 5 && assessmentComplete) {
    levelId = 2
  }

  if (
    levelId === 2 &&
    numOccupationsLiked >= 5 &&
    numOccupations >= 10 &&
    budgetComplete
  ) {
    levelId = 3
  }

  if (levelId === 3 && presentationComplete) {
    levelId = 4
  }
  //console.log(currentLevel, levelId, state.early.gameboard.progress.levelId)

  if (currentLevel < levelId && lastRanFor < levelId) {
    /*
     * console.log(state, state.early.gameboard)
     * const levelName = state.early.gameboard.levels[levelId].name
     */
    const mc = {
      title: t`You've Been Promoted`,
      description: state.early.gameboard.levels[currentLevel].promotionText,
      hasReflection: state.early.gameboard.levels[currentLevel].requiresReflection,
      modalClass: 'bronze'
    }

    if (mc.hasReflection) {
      mc.title = t`You Are Up for a Promotion`
      mc.nextLevel = levelId
      mc.reflectionText = state.early.gameboard.levels[currentLevel].reflectionQuestion
      mc.levelCompleted = currentLevel
    }

    const levelCompleted = currentLevel

    currentLevel = levelId
    lastRanFor = levelId

    if (mc.hasReflection) {
      if (!isEqual(state.early.gameboard.levelModal, mc)) {
        //console.log('Has Ref', mc)
        store.dispatch({ type: PRE_LEVEL, levelContent: mc })
      }
    } else {
      Promise.resolve(
        store.dispatch({ type: SET_LEVEL, levelId, levelContent: mc })
      ).then(() => {
        //console.log(mc)
        if (!mc.hasReflection) {
          store.dispatch(formActions.reset('early.promotionReflection.reflection'))
        }

        store.dispatch(recordLevelProgress(levelCompleted))
      })
    }
  }
}
const handleBadgeChange = store => () => {
  if (!store.getState().early.gameboard.activityLog.dataLoaded) {
    if (lastRanFor < store.getState().early.gameboard.progress.levelId) {
      lastRanFor = store.getState().early.gameboard.progress.levelId
    }

    //console.log("Not Yet: ", store.getState().early.gameboard)
    return null
  }

  const genBadges = state => {
    const pathwayIcon = checkPathwayBadge(state.early.gameboard.activityLog.pathways)
    const occupationIcon = checkOccupationBadge(
      state.early.gameboard.activityLog.occupations
    )
    const ratingIcon = checkRatingBadge(state.early.backpack.ratings)
    const videoIcon = clusterVideoBadge(state.early.gameboard.activityLog.clustervideo)
    let assessmentIcon = {
      level: 0,
      icon: inactiveCheckIcon //'Badges_check-inactive.svg'
    }

    if (state.early.interestActivity.completedAt) {
      assessmentIcon = {
        level: 3,
        icon: goldCheckIcon //'Badges_check-gold.svg'
      }
    }

    let budgetIcon = {
      level: 0,
      icon: inactiveJigsawIcon //'Badges_jigsaw-inactive.svg'
    }

    if (state.early.budget.completedAt) {
      budgetIcon = {
        level: 3,
        icon: goldJigsawIcon //'Badges_jigsaw-gold.svg'
      }
    }

    let userIcon = {
      level: 1,
      icon: inactiveUserIcon //'Badges_user-inactive.svg'
    }

    if (state.early.gameboard.userInfo.avatar) {
      userIcon = {
        level: 1,
        icon: goldUserIcon //'Badges_user-bronze.svg'
      }
    }

    return {
      rating: ratingIcon,
      budget: budgetIcon,
      pathways: pathwayIcon,
      occupations: occupationIcon,
      clusterVideos: videoIcon,
      assessment: assessmentIcon,
      user: userIcon
    }
  }
  const previousValue = currentValue

  checkLevels(store)
  currentValue = genBadges(store.getState())

  if (previousValue && previousValue.pathways.level !== currentValue.pathways.level) {
    const numExplored = store.getState().early.gameboard.activityLog.pathways.length
    const pathwayLevelName = levelName(currentValue.pathways.level)
    const pathwayWord = numExplored > 1 ? t`pathways` : t`pathway`
    const mc = {
      title: t`${pathwayLevelName} Pathway Badge`,
      description: t`Congratulations, you just received the ${pathwayLevelName} Pathway Badge because you've explored ${numExplored} ${pathwayWord}. Keep it up!`,
      icon: currentValue.pathways.icon,
      modalClass: pathwayLevelName.toLowerCase()
    }

    store.dispatch(updateLevel('pathways', currentValue.pathways.level))
    store.dispatch({
      type: BADGES_UPDATED,
      badges: currentValue,
      badgeType: currentValue.pathways,
      modalContent: mc
    })
  } else if (
    previousValue &&
    previousValue.occupations.level !== currentValue.occupations.level
  ) {
    const numExplored = store.getState().early.gameboard.activityLog.occupations.length
    const occupationLevelName = levelName(currentValue.occupations.level)
    const occupationWord = numExplored > 1 ? t`occupations` : t`occupation`
    const mc = {
      title: t`${occupationLevelName} Occupation Badge`,
      description: t`Congratulations, you just received the ${occupationLevelName} Occupation Badge because you've explored ${numExplored} ${occupationWord}. Keep it up!`,
      icon: currentValue.occupations.icon,
      modalClass: occupationLevelName.toLowerCase()
    }

    store.dispatch(updateLevel('occupations', currentValue.occupations.level))
    store.dispatch({ type: BADGES_UPDATED, badges: currentValue, modalContent: mc })
  } else if (previousValue && previousValue.user.level !== currentValue.user.level) {
    const userLevelName = levelName(currentValue.user.level)
    const mc = {
      title: t`${userLevelName} User Badge`,
      description: t`Congratulations, you just received the ${userLevelName} User badge because you added your name to your profile and set your avatar!. Keep it up!`,
      icon: currentValue.user.icon,
      modalClass: userLevelName.toLowerCase()
    }

    store.dispatch(updateLevel('user', currentValue.user.level))
    store.dispatch({ type: BADGES_UPDATED, badges: currentValue, modalContent: mc })
  }

  if (previousValue && previousValue.rating.level !== currentValue.rating.level) {
    const bp = store.getState().early.backpack
    const numRated = bp.ratings.occupations.length + bp.ratings.pathways.length
    const ratingLevelName = levelName(currentValue.rating.level)
    const ratingName = numRated > 1 ? t`items` : t`item`
    //console.log(numRated)
    const mc = {
      title: t`${ratingLevelName} Rating Badge`,
      description: t`Congratulations, you just received the ${ratingLevelName} Rating Badge because you've rated ${numRated} ${ratingName}. Keep it up!`,
      icon: currentValue.rating.icon,
      modalClass: ratingLevelName.toLowerCase()
    }

    store.dispatch(updateLevel('rating', currentValue.rating.level))
    store.dispatch({ type: BADGES_UPDATED, badges: currentValue, modalContent: mc })
  }

  if (
    previousValue &&
    previousValue.clusterVideos.level !== currentValue.clusterVideos.level
  ) {
    const numExplored = store.getState().early.gameboard.activityLog.clustervideo.length
    const videoLevelName = levelName(currentValue.clusterVideos.level)
    const videoName = numExplored > 1 ? t`videos` : t`video`
    const mc = {
      title: t`${videoLevelName} Video Badge`,
      description: t`Congratulations, you just received the ${videoLevelName} Video Badge because you've watched ${numExplored} ${videoName}. Keep it up!`,
      icon: currentValue.clusterVideos.icon,
      modalClass: videoLevelName.toLowerCase()
    }

    store.dispatch(updateLevel('clusterVideos', currentValue.clusterVideos.level))
    store.dispatch({ type: BADGES_UPDATED, badges: currentValue, modalContent: mc })
  } else if (!compareMaps(previousValue, currentValue)) {
    store.dispatch({ type: BADGES_UPDATED, badges: currentValue })
    //console.log('Some deep nested property changed from', previousValue, 'to', currentValue)
  }
  //console.log(store.getState().early)
}

export default handleBadgeChange
